import React from "react";
import "./CertificateGroupingCommon.scss";
import CertificateGroupingCommonFinalReviewForm from "../../features/CertificateGroupingCommonFinalReview/CertificateGroupingCommonFinalReviewForm";

const CertificateGroupingCommonForFinalReview = () => {
  return (
    <div className="analytics-page">
      <CertificateGroupingCommonFinalReviewForm/>
    </div>
  );
};

export default CertificateGroupingCommonForFinalReview;
